import type { FC, ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

interface EmptyStateProps {
    icon: LucideIcon
    title: string
    description?: ReactNode
    action?: ReactNode
    className?: string
    compact?: boolean
}

const EmptyState: FC<EmptyStateProps> = ({
    icon: Icon,
    title,
    description,
    action,
    className,
    compact = false
}): ReactNode => {
    return (
        <div
            className={cn(
                'flex flex-col items-center justify-center rounded-xl border border-dashed border-border bg-background text-center',
                compact ? 'gap-2 px-4 py-8' : 'gap-3 px-6 py-14',
                className
            )}
        >
            <span className={cn('flex items-center justify-center rounded-full bg-accent text-accent-foreground', compact ? 'size-10' : 'size-12')}>
                <Icon className={compact ? 'size-5' : 'size-6'} />
            </span>

            <div className='flex max-w-sm flex-col gap-1'>
                <p className='text-[15px] font-semibold text-foreground'>
                    {title}
                </p>

                {description && (
                    <div className='text-sm text-muted-foreground'>
                        {description}
                    </div>
                )}
            </div>

            {action && (
                <div className='mt-1 flex flex-wrap items-center justify-center gap-2'>
                    {action}
                </div>
            )}
        </div>
    )
}

export default EmptyState
